import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { TaskGroupsPage } from "./TaskGroupsPage";
import { OrganizationTaskGroupsList } from "./OrganizationTaskGroupsList";

export const OrganizationTaskGroups = () => {
    const canManageTaskGroups = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );

    return (
        <TaskGroupsPage
            canManageTaskGroups={canManageTaskGroups}
            scope="organization"
        >
            {(props) => <OrganizationTaskGroupsList {...props} />}
        </TaskGroupsPage>
    );
};
